import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { DocumentType } from '../../../constants/Enums';
import { MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const IconWrapper = styled.div`
  text-align: center;
  margin: 0 auto !important;
`;

export const Wrapper = styled.div`
  ${({ documentType, iconVariation }) =>
    (documentType === DocumentType.PAGE ||
      documentType === DocumentType.TESTIMONIAL) &&
    `
    margin-bottom: 100px;

    & > div {
      max-width: 1000px;
      margin: ${iconVariation ? '50px auto' : '100px auto'};

      ${MediaQuery.L_AND_DOWN} {
        margin: ${iconVariation ? '45px 45px 0 45px' : '0 45px'};
        padding: 0 15px;
      }

      ${MediaQuery.M_AND_DOWN} {
        margin: ${iconVariation ? '45px 15px 0 15px' : '0 15px'};
        padding: 0;
      }
    }

    ${MediaQuery.XL_AND_DOWN} {
      margin-bottom: 60px;
    }
  `}

  ${({ documentType, hasBackground }) =>
    documentType === DocumentType.POST &&
    `
    margin-top: 30px;
    background: ${hasBackground ? Color.WHISPER : ''};
    border-radius: 30px;

    & > div {
      padding: 45px;
    }

    ${MediaQuery.M_AND_DOWN} {
      padding: 0 15px;
    }
  `}
`;

export const HorizontalLine = styled.span`
  border-bottom: 1px solid ${Color.MYSTIC};
  display: block;

  ${MediaQuery.L_AND_DOWN} {
    display: none;
  }
`;

export const Content = styled.div`
  text-align: center;

  p {
    margin: ${({ hasBigTitle }) =>
      hasBigTitle ? '0 0 30px 0' : ' 0 0 15px 0'};
  }
`;

export const Title = styled.p`
  ${Typography.XXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0 0 15px 0;
`;

export const BigTitle = styled.p`
  ${Typography.XXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0 0 50px 0;
`;

export const ButtonWrapper = styled.div`
  & > :last-child {
    margin-left: ${({ hasSecondButton }) => (hasSecondButton ? '10px' : '0px')};
  }

  ${MediaQuery.M_AND_DOWN} {
    & > :last-child {
      margin: ${({ hasSecondButton }) => (hasSecondButton ? '10px 0' : '0')};
    }
  }
`;
